<template>
  <div class="client-detail">
    <div @click="onClick">
      修改每日群发上限
    </div>
    <a-modal
      :title="'修改每日群发上限：' + record.nickname"
      :visible="visible"
      :confirmLoading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      :closable="false"
      :centered="true"
      cancelText="取消"
      okText="确定"
      width="60%"
    >
      <div>
        <label class="info" style="width: 30%">每日群发上限</label>
        <a-input v-model="batchEverydaySendMaxCount" style="width: 80px; margin-right: 10px;"/>
      </div>
    </a-modal>
  </div>
</template>

<script>
import AModal from 'ant-design-vue/es/modal/Modal'
const axios = require('axios')
export default {
  name: 'EditClientEverydayBatchSendMaxCount',
  components: {AModal},
  props: ['record'],
  data () {
    return {
      editEverydayBatchSendMaxCountUrlPostFix: 'UClient/edit_everyday_batch_send_max_count',
      visible: false,
      confirmLoading: false,
      batchEverydaySendMaxCount: this.record.everyday_batch_send_max_count
    }
  },
  computed: {
    editEverydayBatchSendMaxCountUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.editEverydayBatchSendMaxCountUrlPostFix
    }
  },
  watch: {
    record: function (newValue, oldValue) {
      console.log('record', newValue)
      this.batchEverydaySendMaxCount = newValue.everyday_batch_send_max_count
    },
    batchEverydaySendMaxCount: function (newValue, oldValue) {
      // console.log('count', newValue, oldValue)
      var a = parseInt(newValue)
      // console.log('count', a)
      if (isNaN(a) || a < 0) {
        a = 0
      }
      this.batchEverydaySendMaxCount = a
    }
  },
  methods: {
    onClick () {
      // console.log('onClick')
      this.visible = true
    },
    handleOk () {
      console.log('handleOk')
      this.confirmLoading = true
      axios.post(this.editEverydayBatchSendMaxCountUrl, {
        new_count: this.batchEverydaySendMaxCount,
        client_id: parseInt(this.record.client_id),
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            // console.log('重置免费一个群成功')
            // const dataSource = [...this.data]
            // const target = dataSource.find(item => item.client_id === clientId)
            // console.log('target', target)
            // if (target) {
            //   target['probation'] = 1
            //   console.log('dataSource', dataSource)
            //   this.data = dataSource
            // }

            this.$emit('on-finish', this.record.client_id, this.batchEverydaySendMaxCount)
            this.visible = false
            this.confirmLoading = false
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    handleCancel () {
      // console.log('handleCancel')
      this.visible = false
      this.confirmLoading = false
    }
  }
}
</script>

<style scoped>

</style>
